import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiArrowLeft, FiMail, FiMessageSquare } = FiIcons;

export default function Contact() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-indigo-600 transition-colors mb-8">
        <SafeIcon icon={FiArrowLeft} />
        Retour au calculateur
      </Link>

      <div className="flex items-center gap-3 mb-8">
        <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
          <SafeIcon icon={FiMessageSquare} className="text-indigo-600 text-lg" />
        </div>
        <h1 className="text-3xl font-extrabold text-slate-900">Contact</h1>
      </div>

      <div className="bg-white rounded-2xl p-8 ring-1 ring-slate-900/5 shadow-sm text-center">
        <div className="w-16 h-16 bg-indigo-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiMail} className="text-indigo-500 text-2xl" />
        </div>
        <h2 className="text-xl font-bold text-slate-800 mb-3">Une question ? Une suggestion ?</h2>
        <p className="text-slate-500 text-sm leading-relaxed mb-6 max-w-md mx-auto">
          N'hésitez pas à nous écrire pour signaler une erreur de calcul, suggérer une amélioration ou toute autre demande.
        </p>
        <a style={{
      color: 'rgb(255, 255, 255)'
    }}
          href="mailto:contact@salaire-smic.com"
          className="inline-flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl transition-colors shadow-sm shadow-indigo-200"
        >
          <SafeIcon icon={FiMail} />contact@salaire-smic.com</a>
        <p className="text-xs text-slate-400 mt-6">
          Nous nous efforçons de répondre dans un délai de 48 heures ouvrées.
        </p>
      </div>
    </div>
  );
}